export const getCookie = (name) => {
    let cookie = null
    let cookies = mapCookiesToArray();
    cookies.forEach((value) => {
        if (value.substring(0, value.indexOf('=')) === name) {
            cookie = value.substring(value.indexOf('=') + 1, value.length)
        }
    })
    return cookie
}

export const deleteCookie = (name) => {
    let cookies = mapCookiesToArray();
    cookies.forEach((value) => {
        if (value.substring(0, value.indexOf('=')) === name) {
            let time = new Date();
            time.setTime(time.getTime() + (-1 * 24 * 60 * 60 * 1000));
            let expires = "expires=" + time.toUTCString();
            document.cookie = name + '=' + null + ';' + expires
        }
    })
}

export const updateCookie = (name, newValue) => {
    let cookies = mapCookiesToArray();
    cookies.forEach((value) => {
        if (value.substring(0, value.indexOf('=')) === name) {
            document.cookie = name + '=' + newValue
        }
    })
}

export const mapCookiesToArray = () => {
    return document.cookie.split('; ');
}


// WEBPACK FOOTER //
// ./src/utils/cookie.js